import React from "react";
import Routs from "./Routs/Routs";


function App() {


    return (<>

        <div className="App"><Routs/></div>
    </>);
}

export default App;